module.exports = __webpack_public_path__ + "img/icon_support_03.cbdd5bff.png";